module.exports = __webpack_public_path__ + "static/media/logo.bce0cad6.svg";